import { Colors } from '@sigma-frontend-libs/commons'

import { icons } from '@/utils'

import squircle from '@/components/icon/squircle'

export default function(h) {
  let icon = icons.keyboard_arrow_down
  if (this.expanded) {
    icon = icons.keyboard_arrow_up
  }

  return h(
    squircle,
    {
      props: {
        icon,
        color: Colors.grey
      }
    }
  )
}
